import APPCONFIG from "../../constants/Config";
import {Button} from "reactstrap";
import React, {useEffect, useState} from "react";
import {Types} from "../index";
import API from "@beardeddevops/react.api";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'


const UserDocsDisplay = ({user}) => {

	const [dl_front, setDlFront] = useState(null);
	const [dl_back, setDlBack] = useState(null);
	const [docs_pkey, setDocsPkey] = useState(null);
	const [w9, setW9] = useState(null);

	useEffect(() => {
		async function fetchData() {
			let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
			try {
				userModel.object.pkey = user;
				const data = await userModel.submit(null, 'GET_DOCUMENTS');
				if (data && data.items && data.items.length > 0) {
					const item = data.items[0];
					setDlFront(item.dl_front);
					setDlBack(item.dl_back);
					setDocsPkey(item.pkey);
					setW9(item.w9);
				}

			} catch (error) {
				console.log(error, 'error')
			}
		}
		fetchData().then();
	}, [user]);

	const hasAnyDocs = docs_pkey && (dl_front || dl_back || w9);

	return (
		<div style={{display: 'flex', flexDirection: 'column', position: 'relative'}}>
			<div className={'section-title'}>
				<h4 className="section-title">Driver's License</h4>
				<div className={"flex-end text-right"}>
					View W9
					<Button
						style={{marginLeft: 5}}
						color="blue-hoki"
						size={"sm"}
						disabled={!w9}
						title={w9 ? 'View submitted W9' : 'No W9 submitted yet'}
						onMouseDown={() => {
							if (w9 && docs_pkey) {
								window.open(APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/print_w9/" + docs_pkey, "_blank");
							}
						}}
					>
						<PictureAsPdfIcon fontSize={'small'}/>
					</Button>
				</div>
			</div>
			{!hasAnyDocs && (
				<p style={{textAlign: 'center', padding: '2rem 1rem', color: '#666'}}>
					No documents or images have been submitted for this user yet.
				</p>
			)}
			<div className={'row'}>
				<div className={'col-6'}>
					{dl_front && (
						<a
							href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/images?image=' + dl_front}
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/images?image=' + dl_front}
								alt={"Front Driver's License"}
								style={{
									maxWidth: "100%",
									maxHeight: "30rem",
									borderRadius: "8px",
									objectFit: "contain",
									cursor: "pointer",
								}}
							/>
						</a>
					)}
				</div>
				<div className={'col-6'}>
					{dl_back && (
						<a
							href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/images?image=' + dl_back}
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/images?image=' + dl_back}
								alt={"Back Driver's License"}
								style={{
									maxWidth: "100%",
									maxHeight: "30rem",
									borderRadius: "8px",
									objectFit: "contain",
									cursor: "pointer",
								}}
							/>
						</a>
					)}
				</div>
			</div>
		</div>
	)

}

export default UserDocsDisplay;
